<div class="h-full min-h-0 overflow-y-auto">
  <div class="flex flex-col sm:flex-row gap-2 sm:gap-2 items-stretch sm:items-center mb-3 sm:mb-4">
    <app-input-buscador
      placeholder="Buscar categoria por nombre"
      [(valor)]="busquedaCategoria"
      class="flex-1"
      (input)="onBuscarCategoria()"
    />
    <app-button
      label="Nueva Categoria"
      icon="bi bi-plus"
      variant="primary"
      (onClick)="modal_crear_categoria.set(true)"
      class="w-full sm:w-auto"
    />
  </div>
  <div
    class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[repeat(auto-fill,minmax(250px,1fr))] gap-3 sm:gap-4"
  >
    @for (categoria of filtroCategoria(); track categoria.id) {
      <app-card-categoria [categoria]="categoria" (eliminar)="onEliminar($event)" />
    } @empty {
      <div class="col-span-full text-center text-slate-500 py-8 sm:py-10 text-sm sm:text-base">
        No se encontraron categorias.
      </div>
    }
  </div>
</div>
<app-dialog
  header="Crear Nueva Categoria"
  [modal]="true"
  [(visible)]="modal_crear_categoria"
  (onHide)="modal_crear_categoria.set(false)"
  size="md"
>
  @if (modal_crear_categoria() === true) {
    <app-crear-categoria (cerrar)="closeCrearCategoria($event)" />
  }
</app-dialog>
